// https://github.com/jshjohnson/Choices
// https://fusejs.io/api/options.html
import Choices from 'choices.js'

$(document).ready(function() {

  if( !$('body.category-3').length ) return;

  const choicesArgs = {
    removeItemButton: false,
    shouldSort: false,
    fuseOptions: {
      threshold: 0.0,
    },
  }

  window.dropdowns = [];

  const yearFilter = document.getElementById('year-filter');

  if( yearFilter ) {
    const choicesYear = new Choices(yearFilter, choicesArgs);
    dropdowns.push(choicesYear);
    yearFilter.addEventListener( 'change', function(event) {
      let years = [...this.options].filter(option => option.selected).map(option => option.textContent)
      if( years.length ) {
        updateFilters(years);
      }
    });
  }

  const eraFilter = document.getElementById('era-filter');
  if( eraFilter ) {
    const choicesEra = new Choices(eraFilter, choicesArgs);
    dropdowns.push(choicesEra);
    eraFilter.addEventListener( 'change', function(event) {
      let eras = [...this.options].filter(option => option.selected).map(option => option.textContent)
      if( eras.length ) {
        updateFilters(eras);
      }
    });
  }

  const topicFilter = document.getElementById('topic-filter');
  if( topicFilter ) {
    choicesArgs.shouldSort = true;
    const choicesTopic = new Choices(topicFilter, choicesArgs);
    dropdowns.push(choicesTopic);
    topicFilter.addEventListener( 'change', function(event) {
      let topics = [...this.options].filter(option => option.selected).map(option => decodeHtml(option.textContent))
      if( topics.length ) {
        updateFilters(topics);
      }
    });
  }

  const seriesFilter = document.getElementById('series-filter');
  if( seriesFilter ) {
    const choicesSeries = new Choices(seriesFilter, choicesArgs);
    dropdowns.push(choicesSeries);
    seriesFilter.addEventListener( 'change', function(event) {
      let series = [...this.options].filter(option => option.selected).map(option => option.textContent)
      if( series.length ) {
        updateFilters(series);
      }
    });
  }

  $('#archives-search-form').on( 'submit', function( e ) {
    e.preventDefault();
    send_search();
  } );

  $('#search-form-clear').on( 'click', function(e) {
    clearForm();
  } );

  $(document).on( "click", '.entry-summary a', function(event) {
    event.preventDefault();
    clearForm();
    $('#archives-search-form').trigger("reset")
    let val = this.getAttribute('data-value');
    dropdowns.forEach( function( dropdown ) {
      dropdown.setChoiceByValue( val )
    } );
    makeUL([val]);
    send_search();
  });

  // handle page reloads
  if( window.location.search ) {
    // send_search( window.location.search );
    // console.log(window.location.search);
    // convert URL params to array
    // set active values on form
    // dropdowns.forEach( function( dropdown ) {
    //   dropdown.setChoiceByValue( "Accountants and Accounting" )
    // } );
    // makeUL(["Accountants and Accounting"]);
    // submit search
    // send_search();
  }



});

$(document).ready(function() {

  if ( $('.advanced-search-form-wrapper').length > 0 ) {

    $('body').on('change','#archives-list-order',function() {

      var thisOrder = $(this).val();

      $(".archives-list article").sort(sort_posts).appendTo('.archives-list');
      function sort_posts(a, b) {
        if (thisOrder == 'DESC') {
          console.log('desc');
          return ($(b).data('date')) < ($(a).data('date')) ? 1 : -1;
        } else if (thisOrder == 'ASC') {
          return ($(b).data('date')) > ($(a).data('date')) ? 1 : -1;
        } else {
          return ($(b).data('order')) < ($(a).data('order')) ? 1 : -1;
        }
      }

    });

  }

});

function updateHistory() {
  // let excluded_fields = [ 'la_nonce', '_wp_http_referer', 'category' ];
  // let formData = $('#archives-search-form').serializeArray();
  // let urlParams = formData.filter(function(elem) {
  //   return !excluded_fields.includes(elem.name) && elem.value;
  // });
  // history.pushState({}, '', window.location.href.split('?')[0] + '?' + $.param(urlParams));
}

function clearForm() {
  $('.active-filters--wrap').hide();
  var list = $('ul#active-filters')[0];
  list.innerHTML = '';
  $('#archives-list-order')[0].selectedIndex = 0;
  $('.archives-order').hide();
  $('.archives-list')[0].innerHTML = '';
  updateHistory();
}

function updateFilters( values ) {
  // console.log('updateFilters');
  makeUL(values);
}

function send_search( method ) {

  // updateHistory();

  let formData = {
    'action'  : 'laarchivessearch',
    'nonce'   : $('#la_nonce').val(),
    'year'    : $('#year-filter').val(),
    'topic'   : $('#topic-filter').val(),
    //'era'     : $('#era-filter').val(),
    //'series'  : $('#series-filter').val(),
    'category': $('#category-filter').val(),
    's'       : $('#query').val(),
  }

  let $list = $('.archives-list');

  if( method == 'clear' ) {
    $list.html();
    return;
  } else {
    formData.page = 0;
  }

  // console.log(formData);

  $.ajax({
    url: laData.ajaxurl,
    type: 'POST',
    data: formData,
    beforeSend: function( xhr ) {

      let $html = '<article class="search-result-entry no-results loading"><div class="search-result-content"><div class="loader"></div></div></article>';

      laData.page = 0;
      laData.current_page = 1;
      $list.html( $html );
      $('.archives-order').hide();

    },
    success: function( data, textStatus, jqXHR ) {
      if( textStatus === 'success' ) {

        data = JSON.parse(data);

        //console.log(data);

        if( method == 'loadmore' ) {
          $('.search-result-entry.loading').remove();
          $list.append(data.content);
          $('.search-form').collapse('hide');
          laData.current_page++;
        } else {
          $list.html(data.content);
          $('html, body').animate({
            scrollTop: $( '.advanced-search-form-wrapper' ).offset().top - 100
          }, 1000 );
          $('.archives-order').show();
        }

        if( laData.current_page == parseInt(data.max_page) ) {
          $('.load-more').hide(); // if last page, remove the button
        } else if( formData.page == 0 && laData.current_page < parseInt(data.max_page) ) {
          $('.load-more').show();
        }

      }
    }
  });
}

// remove item from selected
function removeActiveFilter( e ) {
  e.preventDefault();
  let val = this.getAttribute('data-value');
  dropdowns.forEach( function( dropdown ) {
    dropdown.removeActiveItemsByValue( val )
  } );
  this.parentNode.remove();
  send_search();
}

function makeUL(array) {

  // compare with existing li's and merge
  let currentFilters = document.getElementById("active-filters").getElementsByTagName("li");
  let listItems = [...currentFilters].map( function(item) {
    return item.textContent;
  });
  let active = [...new Set(listItems)].concat(array)
  let unique = [...new Set(active)]

  // Create the list element:
  var list = $('ul#active-filters')[0];
  list.innerHTML = '';
  for (let i = 0; i < unique.length; i++) {
    // Create the list item:
    let item = document.createElement('li'),
        anchor = document.createElement('a');

    anchor.href = '#';
    anchor.text = unique[i];
    anchor.classList.add("remove-filter");
    anchor.setAttribute('data-value', unique[i]);
    anchor.addEventListener("click", removeActiveFilter);

    // Set its contents:
    item.appendChild(anchor);
    // Add it to the list:
    list.appendChild(item);
  }

  $('.active-filters--wrap').show();
  // Finally, return the constructed list:
  return list;
}

function decodeHtml(html) {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}
